import React, { Fragment } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
import { Container, Row, Col } from "react-bootstrap";
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import Home from "./components/Home";
import UseCases from "./components/UseCases";
import ComingSoon from "./components/ComingSoon";
import WordByWordUpdate from "./components/WordByWordUpdate";
import WordByWordUpdateIns from "./components/WordByWordUpdateIns";
import WordByWordUpdateGita from "./components/WordByWordUpdateGita";
import WordByWordUpdateYou from "./components/WordByWordUpdateYou";
import StockSentiment from "./components/StockSentiment";
import DemoCards from "./components/DemoCards";



function App() {
	return (
		<Router>
		  <div>
			
	
			<Routes>
			  <Route exact path="/" element={<Home/>} />
			  <Route path="/Home" element={<Home/>} />
			  <Route path="/UseCases" element={<UseCases/>} />
			  <Route path="/ComingSoon" element={<ComingSoon/>} />
			  <Route path="/StockSentiment" element={<StockSentiment/>} />
			  <Route path="/HRChat" element={<WordByWordUpdate/>} />
			  <Route path="/InsChat" element={<WordByWordUpdateIns/>} />
			  <Route path="/DemoCards" element={<DemoCards/>} />
			  <Route path="/Gita" element={<WordByWordUpdateGita/>} />
			  <Route path="/YouSearch" element={<WordByWordUpdateYou/>} />
			  
			</Routes>
		  </div>
		</Router>
	  );

	}

/*

import Post from "./components/Post";
import Header from "./components/Header";
import LeftCard from "./components/LeftCard";

const App = () => (
	<Fragment>
		<Header />
        
		<main className="my-5 py-5">
			<Container className="px-0">
				<Row
					noGutters
					className="pt-2 pt-md-5 w-100 
						px-4 px-xl-0 position-relative"
				>
					<Col
						xs={{ order: 2 }}
						md={{ size: 4, order: 1 }}
						tag="aside"
						className="pb-5 mb-5 pb-md-0 
							mb-md-0 mx-auto mx-md-0"
					>
						<LeftCard />
					</Col>

					<Col
						xs={{ order: 1 }}
						md={{ size: 7, offset: 1 }}
						tag="section"
						className="py-5 mb-5 py-md-0 mb-md-0"
					>
						<Post />
					</Col>
				</Row>
			</Container>
		</main>
	</Fragment>
);
*/
export default App;
